export default {
    name: 'tile_card',

    props: {
        tile: {
            type: Object,
            required: true
        },
        currentView: {
            type: String,
            default: 'main'
        },
        isPropertyView: {
            type: Boolean,
            default: false
        }
    },

    emits: ['tile-clicked'],

    data() {
        return ({
            is_hovered: false
        })
    },

    computed: {
        cardStyle() {
            if (!this.tile) {
                return ({
                    '--gradient-start': '#02f0e9',
                    '--gradient-end': '#365b6d'
                })
            }
            
            return ({
                '--gradient-start': this.tile.gradientStart || '#02f0e9',
                '--gradient-end': this.tile.gradientEnd || '#365b6d'
            })
        }
    },

    methods: {
        handleTileClick() {
            if (this.tile && this.tile.id) {
                this.$emit('tile-clicked', this.tile.id);
            }
        },
        
        getButtonText() {
            // When on main dashboard
            if (this.currentView === 'main') {
                return 'View Property';
            }
            // When inside a property view (like Erica, Southdowns, etc.)
            // Check if we're currently in a property view AND this tile is a detail tile
            if (this.isPropertyView) {
                // Check if this tile is a detail tile (has hyphen in ID)
                const isDetailTile = this.tile.id.includes('-');
                if (isDetailTile) {  
                    return 'View Details';
                    
                } 
            }
            // Default fallback
            return 'View Details';
        }
    }
}
